module.exports = __webpack_public_path__ + "static/online_interactive_pitch_deck_cover-4335c6e99cd1f1b72af905de1731292d.png";